<template>
    <div class="pt-3">
        <v-divider></v-divider>
          
    <v-card elevation="0" class="d-flex pa-3 text-caption align-center justify-space-between" sstyle="background: rgba(0,0,0,0.05)">
        <v-img alt="The Media Trade" class="shrink mt-0 mr-2" contain min-width="57"
          src="@/assets/logo-latam.svg" width="127"></v-img>
        <div class="pa-2 mx-auto text-center">
            Copyright {{year}} The Media Trade
        </div>
        <!-- <div class="d-flex py-3 pr-n2 text-caption align-center">
            <div class="pa-2">
                Soporte técnico: <v-btn icon small href="https://wa.me/+5511956638849"><v-icon>mdi-whatsapp</v-icon></v-btn>
            </div>
            <div>
               <v-btn small text to="/" rounded>Guía de uso</v-btn>
            </div>
        </div> -->


    </v-card>
    <v-divider></v-divider>

</div>


</template>
<script>
import moment from 'moment'
export default {
    data: () => ({
        year: moment().format('YYYY')
    })
}
</script>